import React from 'react';
import { CellProps } from 'react-table';
import { CartTableItem } from '../../SupplierCartTable.model';

import CategoriesCellView from './CategoriesCell.view';

type Props = CellProps<CartTableItem> & {};

const CategoriesCell: React.FC<Props> = (props: Props) => {
  return <CategoriesCellView value={props.value}></CategoriesCellView>;
};

CategoriesCell.displayName = 'CategoriesCell';

export default CategoriesCell;
